/**
 * @generated SignedSource<<a3b9a099f76dd8756d9de6575e14a6be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsSecurityVulnerabilityStatus = "CLOSED" | "IGNORED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type Vulnerability$data = ReadonlyArray<{
  readonly status: DevOpsSecurityVulnerabilityStatus | null | undefined;
  readonly url: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"VulnerabilityDropdownItemEntryPoint261BadPattern">;
  readonly " $fragmentType": "Vulnerability";
}>;
export type Vulnerability$key = ReadonlyArray<{
  readonly " $data"?: Vulnerability$data;
  readonly " $fragmentSpreads": FragmentRefs<"Vulnerability">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Vulnerability",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "VulnerabilityDropdownItemEntryPoint261BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "DevOpsSecurityVulnerabilityDetails"
};

(node as any).hash = "bec74e12237a4b9027127f44db1327de";

export default node;
